import { httpClient } from "@/services";
export default {
	state: {
		statementsDefaultRows: null,
		statementsDefaultLimit: null,
		statementsDefaultOrder: null,
		statementsDefaultSort: null,
		statementsDefaultSum: null,
		statementsDefaultTotal: null,
		statementsDefaultTotals: null,
		statementsDefaultFilters: null,
		statementsDefaultDepartments: null,
		statementsDefaultMonth: null,
		defaultPayРistory_months: [],
		defaultPayРistory_rows: [],
		defaultPayРistory_first: [],
		userLogs: [],
		userLogsFilter: [],
	},

	mutations: {
		updateStatementsDefaultCreate( state, payload ) {
			const { departments, month } = payload;
			state.statementsDefaultDepartments = departments;
			state.statementsDefaultMonth = month.reverse();
		},
		updateStatementsDefaultList(state, payload) {
			const { limit, order, rows, sort, sum, total } = payload;
			state.statementsDefaultRows = rows;
			state.statementsDefaultLimit = limit;
			state.statementsDefaultOrder = order;
			state.statementsDefaultSort = sort;
			state.statementsDefaultSum = sum;
			state.statementsDefaultTotal = total;
			state.statementsDefaultTotals = { id: total };
		},
		updateDeleteStatementsDefaultList(state, { id }) {
			const index = state.statementsDefaultRows.findIndex(item => item.id === id);

			if (index !== -1) {
				state.statementsDefaultRows.splice(index, 1);
			}
		},
		updateStatementsDefaultFilters(state, payload) {
			// Function to parse month and year
			const parseMonthYear = (monthYear) => {
				if (monthYear.startsWith("Additional")) {
					const year = parseInt(monthYear.split(" ")[1], 10);
					return { month: 13, year: year || 0 }; // Treat "Additional" as the 13th month
				}

				const [ month, year ] = monthYear.split(" ");
				const months = {
					January: 1,
					February: 2,
					March: 3,
					April: 4,
					May: 5,
					June: 6,
					July: 7,
					August: 8,
					September: 9,
					October: 10,
					November: 11,
					December: 12,
				};
				return { month: months[month] || 0, year: parseInt(year, 10) || 0 };
			};

			// Sort filter_month with "Additional" properly accounted for
			payload.filter_month = payload.filter_month.sort((a, b) => {
				const { month: monthA, year: yearA } = parseMonthYear(a.id);
				const { month: monthB, year: yearB } = parseMonthYear(b.id);

				return yearA !== yearB ? yearB - yearA : monthB - monthA; // Sort by year descending, then month descending
			});

			state.statementsDefaultFilters = payload;
		},

		updateDefaultPayРistory(state, payload) {
			const { months, rows } = payload;

			state.defaultPayРistory_months = months;
			state.defaultPayРistory_rows = rows;
		},
		updateDefaultPayРistoryFirst(state, payload) {
			const { rows } = payload;

			state.defaultPayРistory_first = rows;
		},
		updateUserLogs(state, payload) {
			const { logs, logsFilter } = payload;

			console.log('%c [  payload  ] ', 'color:#bada55', payload );
			state.userLogs = logs;
			state.userLogsFilter = logsFilter;

		},
		deleteDefaultSalaryPayment(state, payload) {
			const { id, data } = payload;
			const { rows } = data;

			// Проверяем и удаляем объект с id = delId
			Object.keys(rows).forEach(key => {
				if (rows[key].salary_payment) {
					rows[key].salary_payment = rows[key].salary_payment.filter(item => item.id !== id);
				}
			});

			state.defaultPayРistory_first = rows;
		},
	},
	actions: {
		async getStatementsDefaultCreate({ dispatch, commit }) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.get('info/statements/create');
				if (data && data.status) {
					commit('updateStatementsDefaultCreate', data);
				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},

		async getStatementsMonthCreate({ dispatch, commit }) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.get('info/statements/create/?type=2');
				if (data && data.status) {
					commit('updateStatementsDefaultCreate', data);
					const isDepartments = data.departments.length === 0;
					if (isDepartments) dispatch('setAlert', { type: "warning", message: "🗂️ No departments found. Check other months." });

				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},

		async getStatementsDefaultCreateMonthType({ dispatch, commit }, values) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.get(`info/statements/create/?month=${ values }&type=2`);
				if (data && data.status ) {
					commit('updateStatementsDefaultCreate', data);
					const isDepartments = data.departments.length === 0;
					if (isDepartments) dispatch('setAlert', { type: "warning", message: "🗂️ No departments found. Check other months." });
				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getStatementsDefaultCreateMonth({ dispatch, commit }, values) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.get(`info/statements/create/?month=${ values }`);
				if (data && data.status ) {
					commit('updateStatementsDefaultCreate', data);
				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async deleteStatementsDefaultList({ dispatch, commit }, id) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.delete(`info/statements/${ id }`);
				if (data && data.status) {
					commit('updateDeleteStatementsDefaultList', { id });
					dispatch('setAlert', { type: "success", message: "Salary payment deleted successfully 🗑️" });
				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getStatementsDefaultList({ dispatch, commit }, values) {
			try {
				// dispatch('actionPreloader', true);
				const { data } = await httpClient.post('info/statements/list', values);
				if (data && data.status) {
					commit('updateStatementsDefaultList', data);
				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				// dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getStatementsDefaultFilters({ dispatch, commit }, values) {
			try {
				// dispatch('actionPreloader', true);
				const { data } = await httpClient.post('info/statements/filters', values);
				if (data && data.filter) {
					commit('updateStatementsDefaultFilters', data.filter);
				} else {
					// commit('updateUser', { user: null, managers: null });
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				// dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		// async onEditPassword(ctx, values) {
		// 	try {
		// 		return await httpClient.post('/user/update', values);
		// 	} catch (e) {
		// 		console.error(e);
		// 	}
		// }

		// async getDefaultPayРistory({ dispatch, commit }, id ) {
		async getDefaultPayРistory({ dispatch, commit }) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post(`/info/pay-history/list` );

				if (data) {
					commit('updateDefaultPayРistory', data);
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async getDefaultPayРistoryPrev({ dispatch }, values ) {
			try {
				dispatch('actionPreloader', true);
				// const { id, date } = values;
				const { date } = values;
				// const { data } = await httpClient.post(`/info/pay-history/${ id }`, { date } );
				const { data } = await httpClient.post(`/info/pay-history/list`, { date } );

				// if (data) {
				// 	commit('updateDefaultPayРistoryPrev', data);
				// } else {
				// 	dispatch('setAlert', { type: "error", message: "Server Error" });
				// }
				dispatch('actionPreloader', false);

				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async getDefaultSalaryPay({ dispatch, commit }, values ) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post(`/info/pay-history`, values );
				if (data && data.status === true) {
					commit('updateDefaultPayРistoryFirst', data);
					dispatch('setAlert', { type: "success", message: "Data successfully updated 👌" });
				} else {
					dispatch('setAlert', { type: "error", message: "Server Error" });
				}
				dispatch('actionPreloader', false);
				dispatch('actionPreloader', false);

			} catch (e) {
				console.error(e);
			}
		},
		async deleteDefaultSalaryPayment({ dispatch, commit }, id) {
			try {
				const { data } = await httpClient.delete(`/info/pay-history/${ id }`);
				if (data) {
					commit('deleteDefaultSalaryPayment', { id, data });
					dispatch('setAlert', { type: "success", message: "Salary payment deleted successfully 🗑️" });
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getUserLogs({ dispatch, commit }, values ) {
			try {
				dispatch('actionPreloader', true);
				const { data } = await httpClient.post(`/employees/filterLogs`, values );
				if (data) {
					commit('updateUserLogs', data);
					dispatch('actionPreloader', false);

				}
				dispatch('actionPreloader', false);

			} catch (e) {
				console.error(e);
			}
		},

	},
	getters: {
		statementsDefaultRows: s => s.statementsDefaultRows,
		statementsDefaultLimit: s => s.statementsDefaultLimit,
		statementsDefaultOrder: s => s.statementsDefaultOrder,
		statementsDefaultSort: s => s.statementsDefaultSort,
		statementsDefaultSum: s => s.statementsDefaultSum,
		statementsDefaultTotal: s => s.statementsDefaultTotal,
		statementsDefaultTotals: s => s.statementsDefaultTotals,
		statementsDefaultFilters: s => s.statementsDefaultFilters,
		statementsDefaultDepartments: s => s.statementsDefaultDepartments,
		statementsDefaultMonth: s => s.statementsDefaultMonth,
		defaultPayРistory_months: s => s.defaultPayРistory_months,
		defaultPayРistory_rows: s => s.defaultPayРistory_rows,
		defaultPayРistory_first: s => s.defaultPayРistory_first,
		userLogs: s => s.userLogs,
		userLogsFilter: s => s.userLogsFilter,
	}
};
